import styled from "styled-components";
import { colors } from "../../../../theme/color";

export const HomeProductWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HomeProductModal = styled.div`
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  width: 47%;
  //    height: 92vh;
  overflow-y: scroll;
  background-color: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 1024px) {
    width: 60%;
  }

  @media screen and (max-width: 768px) {
    width: 90%;
    max-height: 90vh;
  }
`;

export const HomeProductHeader = styled.div`
  height: 90px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${colors.PRIMARY_GREY};
`;

export const HomeProductCloseButton = styled.button`
  background-color: ${colors.White};
  border: none;
  font-size: 18px;
  margin-right: 40px;
  border: 1px solid #e8eaed;
  border-radius: 50%;
  padding: 4px;
  width: 30px;
  height: 30px;
`;

export const HomeProductDetail = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: rows;
  align-items: center;
  align-content: center;
`;

export const HomeProductText = styled.span`
  font-size: 26px;
  align-text: center;
  font-weight: 600;
`;

export const HomeProductImg = styled.img`
  display: flex;
  font-size: 15px;
  padding-left: 5px;
`;

export const HomeProductBody = styled.h4`
  width: 90%;
  padding-left: 30px;
`;

export const HomeProductBodyText = styled.span`
  color: #5e5e5e;
  font-size: 14px;
  font-weight: 400;
`;

export const HomeProductCard = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 30px;
  row-gap: 0;
  // box-shadow: 0px 4px 4px 0px #EAEAEA40;
`;

export const HomeProductMapped = styled.h4``;

export const HomeProductButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const HomeButtonCancel = styled.div`
  display: flex;
  width: 20%;
`;

export const HomeButtonContinue = styled.div`
  display: flex;
  width: 30%;
  padding-left: 20px;
`;

// export const HomeProductText = styled.h4`

// `;
